module.exports = __webpack_public_path__ + "img/Sakralbau_1_a.3fbcbf0c.jpg";